import { useMemo } from 'react';
import type { FunctionComponent } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';
import map from 'lodash/map';
import Points from './Points';
import Text from '../components/atoms/Text';
import { findConceptByName } from '../data/Concepts';
import { getBonusScore, getCombinations } from '../data/Combinations';

const Combination = styled.div`
	background-color: ${(props) => props.theme.colors.white};
	border-radius: 1em;
	margin: 1em;
	padding: 0.25em 1em;
	& h2,
	h3 {
		color: ${(props) => props.theme.colors.darkBlue};
	}
	& dt {
		font-weight: bold;
	}
	& dt:after {
		content: ':';
	}
	& dd {
		margin-bottom: 0.25em;
	}
`;

interface Props {}

const ConceptList: FunctionComponent<Props> = () => {
	const { t } = useTranslation();

	const combinationItems = useMemo(() => {
		return map(getCombinations(), (combination) => {
			const concepts = map(combination.concepts, (conceptName) => {
				const concept = findConceptByName(conceptName);
				if (concept) {
					return <li>{t(concept?.texts.name)}</li>;
				}
				return null;
			});
			const score = getBonusScore(combination);
			return (
				<Combination key={combination.name}>
					<h2>{combination.name}</h2>
					<h3>
						<Trans>data.concepts</Trans>
					</h3>
					<ul>{concepts}</ul>
					<h3>
						<Trans>data.points</Trans>
					</h3>
					<dl>
						<dt>Environment</dt>
						<dd>
							<Points value={score.environment} />
						</dd>
						<dt>Quality Of Life</dt>
						<dd>
							<Points value={score.qualityOfLife} />
						</dd>
						<dt>Happiness</dt>
						<dd>
							<Points value={score.happiness} />
						</dd>
					</dl>
					<h3>
						<Trans>data.texts</Trans>
					</h3>
					<dl>
						<dt>Reason</dt>
						<dd>
							<Text content={t(combination.texts.reason)} />
						</dd>
					</dl>
				</Combination>
			);
		});
	}, [t]);

	return <>{combinationItems}</>;
};

export default ConceptList;
